import styled from "styled-components";

interface StyledSpinnerProps {

}

const Spinner = styled.div<StyledSpinnerProps>`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: radial-gradient(farthest-side,#474bff 94%,#0000) top/9px 9px no-repeat,
    conic-gradient(#0000 30%,#474bff);
    -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 9px),#000 0);
    animation: spinner-c7wet2 1s infinite linear;
    margin: 12px 0;

    @keyframes spinner-c7wet2 {
        100% {
            transform: rotate(1turn);
        }
    }
`;

export default Spinner;
